<script setup lang="ts">
import type { UserSubscripiton } from '@/views/BillingView.vue'

const props = defineProps<{
  userSubscription: UserSubscripiton | null
}>()
</script>

<template>
  <div class="col-12 col-md paddingFixerSingle">
    <div class="myCard column q-pa-md" bordered>
      <h6>Subscription Details</h6>
      <div class="row justify-between">
        <p class="text-grey-6">Current Plan</p>
        <p>{{ props.userSubscription?.plan }}{{ props.userSubscription?.status === 'trialing' ? ' (Trial)' : '' }}</p>
      </div>
      <div class="row justify-between">
        <p class="text-grey-6">Status</p>
        <p
          class="text-capitalize"
          :class="{
            'text-negative': props.userSubscription?.status === 'inactive',
            'text-positive': props.userSubscription?.status === 'active',
            'text-warning': props.userSubscription?.status === 'trialing'
          }"
        >
          {{ props.userSubscription?.status === 'trialing' ? 'In Trial' : props.userSubscription?.status }}
        </p>
      </div>
      <div class="row justify-between">
        <p class="text-grey-6">Next Renewal</p>
        <p>
          {{
            new Date(props.userSubscription?.current_period_end!).toLocaleDateString('en-US', {
              month: 'short',
              day: 'numeric',
              year: 'numeric'
            })
          }}
        </p>
      </div>
      <div class="row justify-between" v-if="props.userSubscription?.status === 'trialing'">
        <p class="text-grey-6">Trial Ends</p>
        <p class="text-warning">
          {{
            new Date(props.userSubscription.trialEnd!).toLocaleDateString('en-US', {
              month: 'short',
              day: 'numeric',
              year: 'numeric'
            })
          }}
        </p>
      </div>
    </div>
  </div>
</template>
